import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import PerguntasFrequentes from '../components/perguntas-frequentes'
import FaleComigo from '../components/fale-comigo'
import Footer from '../components/footer'
import './poltica-de-privacidade.css'

const PolticaDePrivacidade = (props) => {
  return (
    <main className="poltica-de-privacidade-container1">
      <Helmet>
        <title>
          Poltica-de-Privacidade - Adv. Wanderson H Cavalari - Cuiabá
        </title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Poltica-de-Privacidade - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <img
        alt="Rectangle972231"
        sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
        src="/external/rectangle972231-yol9-1500h.webp"
        srcSet="/external//rectangle972231-yol9-1500h.webp 1200w, /external/rectangle972231-yol9-tablet.webp 800w, /external/rectangle972231-yol9-mobile.webp 480w"
        className="poltica-de-privacidade-rectangle97"
      />
      <Header rootClassName="headerroot-class-name8"></Header>
      <div className="poltica-de-privacidade-container2">
        <div className="poltica-de-privacidade-frame46">
          <span className="poltica-de-privacidade-text10">Advogado</span>
          <span className="poltica-de-privacidade-text11">
            <span>Política de</span>
            <br></br>
            <span>Privacidade</span>
            <br></br>
          </span>
          <span className="poltica-de-privacidade-text16">
            <br></br>
            <span className="poltica-de-privacidade-text18">
              SEÇÃO I - INFORMAÇÕES GERAIS
            </span>
            <br></br>
            <span>
              Nesta política de privacidade será informado a maneira que ocorre
              o
            </span>
            <br></br>
            <span>
              tratamento dos dados pessoais das pessoas que acessam o site
              www.whc.adv.br informando assim, de forma transparente quais são
              os dados, qual o intuito da coleta e a maneira que os visitantes
              podem controlar ou deletar suas informações.
            </span>
            <br></br>
            <span>
              Este texto foi criado de acordo com a lei de Proteção de Dados
              Pessoais (Lei /18), o Marco Civil da Internet (Lei 12.965 /14) e
              também o Regulamento da UE n. 2016/6790. Vale ressaltar que, este
              texto poderá sofrer alterações por conta de eventuais atualizações
              normativas.
            </span>
            <br></br>
            <span>
              Informamos que toda e qualquer informação pessoal coletada por por
              nosso website www.whc.adv.br será utilizada para melhorar a sua
              experiência ao navegar em nosso website, visando desta maneira que
              sua visita se torne mais vantajosa e assertiva.
            </span>
            <br></br>
            <span>
              A confidencialidade das informações pessoais dos usuários do site
              www.whc.adv.br é de suma importância para nossa equipe, por este
              motivo, buscamos otimizar continuamente todos os processos
              internos, mantendo a segurança de acordo com todas as normas
              impostas.
            </span>
            <br></br>
            <br></br>
            <span className="poltica-de-privacidade-text31">
              SEÇÃO II - COLETA DOS DADOS
            </span>
            <br></br>
            <span>
              Os dados pessoais dos visitantes podem ser coletados quando:
            </span>
            <br></br>
            <span>
              II.I - O indivíduo realiza a criação de um cadastro no site
              www.whc.adv.br e com base nisso podem ser solicitados dados como:
              email, nome, cidade, telefone, etc.
            </span>
            <br></br>
            <span>
              II.II - O indivíduo navega nas páginas de nosso site
              www.whc.adv.br e neste caso, podem ser coletados dados como:
              palavras-chaves de origem do buscador, comentários, navegador
              utilizado, IP da rede, etc.
            </span>
            <br></br>
            <span>
              II.III - Por meio de terceiros, tais como: Google e/ou Facebook,
              sendo que, no momento de logar em um destes sites é autorizado
              diretamente pelo terceiro.
            </span>
            <br></br>
            <br></br>
            <span>
              No caso de envio de newsletters ou até mesmo envio de avisos por
              e-mail os cookies podem ser utilizados para direcionar um conteúdo
              mais adequado ao usuário final, com o intuito de melhorar a
              experiência de quem está lendo o e- mail, vale ressaltar que cada
              provedor de email possui suas diretrizes.
            </span>
            <br></br>
            <br></br>
            <span className="poltica-de-privacidade-text45">
              SEÇÃO III - ACEITE
            </span>
            <br></br>
            <span>
              A partir do momento da utilização do website www.whc.adv.br
              pressupõe que o usuário aceitou a política de privacidade. Desta
              forma reservamos ao direito de modificar esta política sem que
              seja realizado um aviso prévio. Por este motivo, nós recomendamos
              que os usuários realizem uma consulta regularmente a nossa
              política, para que desta forma, se mantenham sempre atualizados de
              possíveis alterações, caso seja necessário é possível entrar em
              contato através de nosso e-mail: contato@whc.adv.br informando
              suas dúvidas.
            </span>
            <br></br>
            <span>
              O desenvolvedor poderá coletar informações pessoais do usuário que
              acessa o site, tais como nome, e-mail, número de telefone fixo
              e/ou celular, endereço, data de nascimento, ip e/ou outros dados.
              Na grande maioria das vezes, esses dados são utilizados para
              ativar a função de geotarget (exibir determinados conteúdos de
              acordo com a localização) e também filtrando por tipo de usuário
              (analisando a necessidade de cada um).
            </span>
            <br></br>
            <br></br>
            <span className="poltica-de-privacidade-text52">
              SEÇÃO IV - VINCULO A SITES EXTERNOS
            </span>
            <br></br>
            <span>
              O site www.whc.adv.br pode conter vinculo com sites externos,
              estes que podem possuir ferramentas e/ou informações proveitosas
              para os usuários. Esta política de privacidade não é empregada aos
              sites externos, se for do interesse do usuário, o mesmo deverá
              acessar a política de privacidade do site em questão para ter
              conhecimento dos detalhes.
            </span>
            <br></br>
            <br></br>
            <span className="poltica-de-privacidade-text57">OS ANÚNCIOS</span>
            <br></br>
            <span>
              Visando o pagamento de custos de manutenção do site, são exibidos
              anúncios em nosso site, durante a exibição destes é coletado
              algumas informações, tais como: IP, ISP , Browser, Tempo de
              permanência.
            </span>
            <br></br>
            <br></br>
            <span className="poltica-de-privacidade-text62">
              ANÁLISE DE DADOS
            </span>
            <br></br>
            <span>
              A nossa empresa utiliza o serviço do Google Analytics para
              mensurar, calcular e analisar todo o tráfego que recebe no site
              www.whc.adv.br esta ferramenta coleta e processa os dados de
              acordo com a sua própria política, partindo do pressuposto da
              aceitação do usuário final, a política está disponível nos links
              abaixo:
            </span>
            <br></br>
            <br></br>
            <span>
              {' '}
              • https://www.google.com/intl/pt-BR/policies/privacy/partners/
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
            <span>
              •
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noreferrer noopener"
            >
              https://policies.google.com/privacy
            </a>
            <br></br>
            <span>
              •
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <a
              href="https://policies.google.com/terms"
              target="_blank"
              rel="noreferrer noopener"
            >
              https://policies.google.com/terms
            </a>
            <br></br>
            <br></br>
            <span>
              Vale ressaltar que no caso do Google ou Parceiros deste,
              utilizarem os dados coletados, a responsabilidade é única e
              exclusiva destes, desta forma o site www.whc.adv.br se isenta de
              qualquer responsabilidade por consequência do uso dos dados.
            </span>
            <br></br>
            <br></br>
            <span className="poltica-de-privacidade-text77">ATUALIZAÇÃO</span>
            <br></br>
            <br></br>
            <span>
              Essa politica de privacidade obteve sua última atualização na data
              de
            </span>
            <br></br>
            <span>
              08/02/2024, podendo ser modificada a qualquer momento, sem aviso
              prévio.
            </span>
          </span>
        </div>
        <div id="faq" className="poltica-de-privacidade-container3"></div>
        <div id="faq" className="poltica-de-privacidade-container4">
          <PerguntasFrequentes rootClassName="perguntas-frequentesroot-class-name3"></PerguntasFrequentes>
        </div>
        <div id="falecomigo" className="poltica-de-privacidade-container5">
          <FaleComigo></FaleComigo>
        </div>
      </div>
      <Footer></Footer>
      <a
        href="https://wa.me/65992993749"
        target="_blank"
        rel="noreferrer noopener"
        className="poltica-de-privacidade-link3"
      >
        <img
          alt="image"
          src="/external/vectori284-5qgl.svg"
          className="poltica-de-privacidade-image"
        />
      </a>
    </main>
  )
}

export default PolticaDePrivacidade
